import { render, staticRenderFns } from "./MRC_ESS_DynamicForm.vue?vue&type=template&id=108efcc8&"
import script from "./MRC_ESS_DynamicForm.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_DynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108efcc8')) {
      api.createRecord('108efcc8', component.options)
    } else {
      api.reload('108efcc8', component.options)
    }
    module.hot.accept("./MRC_ESS_DynamicForm.vue?vue&type=template&id=108efcc8&", function () {
      api.rerender('108efcc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_DynamicForm.vue"
export default component.exports